import { render, staticRenderFns } from "./wetCatPay.vue?vue&type=template&id=5087b6c8&scoped=true"
import script from "./wetCatPay.vue?vue&type=script&lang=js"
export * from "./wetCatPay.vue?vue&type=script&lang=js"
import style0 from "./wetCatPay.vue?vue&type=style&index=0&id=5087b6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087b6c8",
  null
  
)

export default component.exports